import { render, staticRenderFns } from "./Modale.vue?vue&type=template&id=07fc057c&"
import script from "./Modale.vue?vue&type=script&lang=js&"
export * from "./Modale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports